import { SHORT_MONTHS } from '../constants'

export const noOp = () => {};

export const scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
}

export const splitFacets = (facets) => {
    //Only splits on commas not between double quotes.
    return facets.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
}

// check whether space or double quotation marks are present
export const containsSpaceOrDoubleQuote = (val) => val && (/\s/g.test(val) || val?.toString()?.includes('"'));

//check whether special character for facets is present
export const containsSpecialCharacterForFacets = (val) => val && /[^a-zA-Z0-9-]/.test(val);

// escape double quotation marks
export const escapeDoubleQuotes = (optionValue) => optionValue?.toString()?.replace(/"/g, '\\"');


/**
 * Filters the sort options based on the hideLoggedOutPricing parameter.
 * @param {Array} options - The array of sort options to filter.
 * @param {boolean} hideLoggedOutPricing - A flag to determine if certain options should be hidden.
 * @returns {Array} - The filtered array of sort options based on the hideLoggedOutPricing parameter.
 */
export const filterSortOptions = (options, hideLoggedOutPricing) => {
  if (hideLoggedOutPricing) {
    return options.filter(option => option.value !== 'price_descending' && option.value !== 'price_ascending');
  } else {
    return options;
  }
};

const LOCALE_TO_CURRENCY_MAP = {
  CA: 'CAD',
  US: 'USD',
  GB: 'GBP',
  IE: 'EUR',
  SE: 'SEK',
  DE: 'EUR',
  NL: 'EUR',
  BE: 'EUR',
  AT: 'EUR',
  CH: 'CHF',
  FR: 'EUR',
  IT: 'EUR',
  ES: 'EUR',
  AU: 'AUD',
  CN: 'CNY',
  HK: 'HKD',
  NZ: 'NZD',
  SG: 'SGD',
}

export const getDefaultCurrencyByLocale = (locale) => {
  const countryCode = (locale || '').split('_')[1]?.toUpperCase()
  return LOCALE_TO_CURRENCY_MAP[countryCode] || 'USD';
}

export const formatToDisplayDate = (date) => {
  if (date == null || date === '') return '';

  const numericDate = Number(date);
  // Non-numeric values (e.g. an already-formatted string like "15 Aug 2022")
  // are not epoch timestamps — return them as-is instead of producing "NaN undefined NaN".
  if (!Number.isFinite(numericDate)) {
    return String(date);
  }

  const dateObj = new Date(numericDate);

  const day = dateObj.getUTCDate()
  const month = SHORT_MONTHS[dateObj.getUTCMonth()];
  const year = dateObj.getUTCFullYear();
  
  return `${day} ${month} ${year}`;
}